import { db } from "./firebase/firebaseconfig";
import { 
  collection, 
  doc, 
  getDocs, 
  getDoc, 
  addDoc, 
  updateDoc, 
  deleteDoc,
  query,
  orderBy,
  where
} from 'firebase/firestore';

const COLLECTION_NAME = 'featuredProducts';

const homeProductsService = {
  // Get all featured products
  getAllFeaturedProducts: async () => {
    try {
      const q = query(
        collection(db, COLLECTION_NAME),
        orderBy('order', 'asc')
      );
      const querySnapshot = await getDocs(q);
      
      const featured = [];
      querySnapshot.forEach((doc) => {
        featured.push({
          id: doc.id,
          ...doc.data()
        });
      });

      return {
        success: true,
        featured
      };
    } catch (error) {
      console.error('Error getting featured products:', error);
      return {
        success: false,
        error: error.message
      };
    }
  },

  // Get active featured products only
  getActiveFeaturedProducts: async () => {
    try {
      const q = query(
        collection(db, COLLECTION_NAME),
        where('isActive', '==', true),
        orderBy('order', 'asc')
      );
      const querySnapshot = await getDocs(q);
      
      const featured = [];
      querySnapshot.forEach((doc) => {
        featured.push({
          id: doc.id,
          ...doc.data()
        });
      });

      return {
        success: true,
        featured
      };
    } catch (error) {
      console.error('Error getting active featured products:', error);
      return {
        success: false,
        error: error.message
      };
    }
  },

  // Get single featured product
  getFeaturedProduct: async (id) => {
    try {
      const docRef = doc(db, COLLECTION_NAME, id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        return {
          success: true,
          featured: {
            id: docSnap.id,
            ...docSnap.data()
          }
        };
      } else {
        return {
          success: false,
          error: 'Featured product not found'
        };
      }
    } catch (error) {
      console.error('Error getting featured product:', error);
      return {
        success: false,
        error: error.message
      };
    }
  },

  // Add new featured product
  addFeaturedProduct: async (featuredData) => {
    try {
      const docRef = await addDoc(collection(db, COLLECTION_NAME), {
        ...featuredData,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      });

      return {
        success: true,
        featured: {
          id: docRef.id,
          ...featuredData
        }
      };
    } catch (error) {
      console.error('Error adding featured product:', error);
      return {
        success: false,
        error: error.message
      };
    }
  },

  // Update featured product
  updateFeaturedProduct: async (id, featuredData) => {
    try {
      const docRef = doc(db, COLLECTION_NAME, id);
      await updateDoc(docRef, {
        ...featuredData,
        updatedAt: new Date().toISOString()
      });

      return {
        success: true,
        featured: {
          id,
          ...featuredData
        }
      };
    } catch (error) {
      console.error('Error updating featured product:', error);
      return {
        success: false,
        error: error.message
      };
    }
  },

  // Delete featured product
  deleteFeaturedProduct: async (id) => {
    try {
      const docRef = doc(db, COLLECTION_NAME, id);
      await deleteDoc(docRef);

      return {
        success: true,
        id
      };
    } catch (error) {
      console.error('Error deleting featured product:', error);
      return {
        success: false,
        error: error.message
      };
    }
  },

  // Toggle active status
  toggleActive: async (id, currentStatus) => {
    try {
      const docRef = doc(db, COLLECTION_NAME, id);
      await updateDoc(docRef, {
        isActive: !currentStatus,
        updatedAt: new Date().toISOString()
      });

      return {
        success: true,
        isActive: !currentStatus
      };
    } catch (error) {
      console.error('Error toggling active status:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }
};

export default homeProductsService;